<template>
  <div class="moow-master-container play-background">
    <header-alt :overlay="true"></header-alt>
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container fluid class="filter-container-hero">
      <div class="container vert-cent">
        <b-row>
          <b-col lg="6" md="6" sm="10">
            <md-card md-with-hover class="mt-5 island-card">
              <md-card-header style="text-align:center;" class="mt-5">
                <b-row>
                  <b-col>
                    <p class="moow-hero-title center mb-2">{{i18n_local.signup}}</p>
                    <p>
                      {{i18n_local.have_account}}
                      <router-link to="login">{{i18n_local.login_here}}</router-link>
                    </p>
                  </b-col>
                </b-row>
              </md-card-header>

              <md-card-content style="text-align:center;">
                <register-form
                  @emitSuccessfulRegistration="successfulRegistration"
                  @emitFailedRegistration="failedRegistration"
                  @emitLoading="toggleLoading"
                ></register-form>
              </md-card-content>
            </md-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import Snackbar from "@/components/snackbar.vue";
import TermsAndConditions from "@/components/dialogs/TermsAndConditions.vue";
import RegisterForm from "./registerForm.vue";
import { mapGetters } from "vuex";

import {
  captureMessage,
  captureException
} from "@/utils/reporting/reportingService.js";
export default {
  props: {
    connectToPersonId: {
      type: String,
      required: false
    }
  },
  name: "Register",
  components: {
    snackbar: Snackbar,
    "register-form": RegisterForm
  },
  data() {
    return {
      loading: false
    };
  },
  created() {
    if (this.$store.getters.isUserLoggedIn) this.navigateTo({name: "dashboard"});
  },
  watch: {},
    computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"])
  },
  methods: {
    toggleLoading(value) {
      this.loading = value;
    },
    successfulRegistration() {
      this.redirect();
    },
    failedRegistration(error) {
      this.toggleLoading(false);
    },
    redirect() {
      let redirectComponent = this.$route.query.redirect;
      if (redirectComponent == "chat") this.redirectToChat();
      else{
        if(!redirectComponent) redirectComponent = "dashboard";
        this.navigateTo({name: redirectComponent});
      }
    },
    redirectToChat() {
      this.navigateTo({
        name: "chat",
        params: {
          chatWithThisUser: this.chatWithThisUser,
          initialChatMsg: this.initialChatMsg,
          regardingPropery: this.regardingPropery
        }
      });
    },
    navigateTo({ name, params }) {
      this.$router.push({
        name: name,
        params: params
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/auth/Register.vue